import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-illinois-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./illinois-state-form.component.html",
  styleUrl: "./illinois-state-form.component.scss",
})
export class IllinoisStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
